import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  createdAt: () => faker.date.recent(),

  approvalStatus() {
    return faker.helpers.arrayElement(['review', 'approved', 'denied']);
  },

  userDocument: null,

  asApproved: trait({
    approvalStatus: 'approved',
  }),

  asDenied: trait({
    approvalStatus: 'denied',
  }),

  asReview: trait({
    approvalStatus: 'review',
  }),
});
